import React from 'react';
import './ShipType.scss';

interface ShipTypeProps {
  shipType: string;
}

const ShipType: React.FC<ShipTypeProps> = ({ shipType }) => {
  const SHIP_TYPES: { [key: string]: string } = {
    mto: 'Made-to-order',
    standard: 'Standard',
    flash: 'Flash',
    expedited: 'Expedited',
    individually_shipped: 'Individual',
    economy: 'Economy',
  };

  return <div className={`ship-type-label ${shipType}`}>{SHIP_TYPES[shipType]}</div>;
};

export default ShipType;
